import React from "react";
import { useSelector } from "react-redux";
import ProjectMain from "../components/Projects/ProjectMain";
import ProjectSkeleton from "../components/Projects/PreparationPhase/Step_1_ProjectSummary-Skeleton";

export default function ProjectPage() {
    const project = useSelector((state) => state.projects.selectedProject);
    const organisations = useSelector((state) => state.organisations.organisations);
    const users = useSelector((state) => state.users.users);
    const isLoading = useSelector((state) => state.projects.loading);

    if (
        !project || 
        isLoading === true ||
        organisations.length === 0 ||
        users.length === 0

    ) {
        return <ProjectSkeleton />;
    }

    return (
        // <Container maxWidth={false}>
        <ProjectMain project={project} />
        // </Container>
    );
}
